import React, {Component} from "react";
import CustomForm from "../../../shared/components/form/CustomForm";
import {validateRequired, validateNumber} from "../../../shared/components/form/ValidationFunctions";

const CreatePhaseFormConfig = {
  fields: {
    header: {
      type: 'text',
      label: 'Phase name (ex. Phase #)',
      placeholder: 'Phase name',
      rules: [validateRequired('Phase name')],
    },
    weeks: {
      type: 'select',
      label: '# of Weeks',
      rules: [validateRequired('Weeks')],
      value: 'value',
      optionLabel: 'label',
      options: [{
        value: 1,
        label: '1'
      }, {
        value: 2,
        label: '2'
      }, {
        value: 3,
        label: '3'
      }, {
        value: 4,
        label: '4'
      }, {
        value: 5,
        label: '5'
      }, {
        value: 6,
        label: '6'
      }]
    },
  }
}

class CreatePhaseForm extends Component {
  render() {
    return <CustomForm
      config={CreatePhaseFormConfig}
      onSubmit={(data) => this.props.onSubmit(data)}
      isLoading={this.props.isLoading}
      initialValues={{weeks: 1}}
    />
  }
}

export default CreatePhaseForm;
